import { AxiosRequestConfig } from "axios";

import { createApiQueryHook, IOrderable, IPaginateable, mapOrder, mapPagination } from "../../utils/api";
import { serialize } from "../../utils/url";
import { IFactoryList } from "../types/IFactoryList";

export interface IFactoryListQueryParameters extends IPaginateable, IOrderable<"title" | "createdAt" | "updatedAt"> {
    filters?: {
        title?: string;
    };
}

export type IFactoryListQueryResult = IFactoryList;

const mapFilters = (filters: IFactoryListQueryParameters["filters"]) => {
    const { title } = filters ?? {};

    return {
        title,
    };
};

export const factoryListQuery = ({ pagination, order, filters }: IFactoryListQueryParameters): AxiosRequestConfig => {
    return {
        method: "GET",
        url: `/factories${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useFactoryListQuery = createApiQueryHook<IFactoryListQueryParameters, IFactoryListQueryResult>(
    factoryListQuery,
);
